import React, { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import AppPage from "../app/AppPage";
import { manageableWorkspaces } from "../../utils/permissions";
import { currentWorkspace, rememberedDatabase, switchWorkspace } from "../../utils/readingContext";
import { switchDatabaseInPlace } from "../../utils/switchDatabase";
import WorkspaceView from "./WorkspaceView";
import { Surface, menuPaper } from "./WorkspaceUi";

// Manage workspace: a Workspace admin's own workspace, in the same view the
// console uses (the Plan tab is read-only here). Replaces Workspace.jsx.
export default function ManageWorkspace({ user }) {
  const history = useHistory();
  const manageable = manageableWorkspaces(user);
  // Opens on the workspace the person is working in (the one the account menu
  // names), where they administer it; otherwise the first they do.
  const working = currentWorkspace(user);
  const signedIn = manageable.find((w) => w.id === working?.id);
  const [chosen, setChosen] = useState(signedIn?.id || manageable[0]?.id || null);

  if (!chosen) return <Redirect to="/home" />;

  return (
    <AppPage
      title="Manage workspace"
      description="Your workspace's people, views and databases."
      actions={
        manageable.length > 1 ? (
          <TextField
            select
            size="small"
            label="Workspace"
            value={chosen}
            onChange={(e) => {
              // Managing another workspace is also working in it: the rest of
              // the app follows, so the two never disagree - including the
              // database, which moves with the workspace where the one open
              // isn't one it gives (utils/readingContext.js). The page stays
              // where it is; only what is behind it is re-read.
              setChosen(e.target.value);
              switchWorkspace(user, e.target.value, rememberedDatabase(), history, switchDatabaseInPlace);
            }}
            SelectProps={{ MenuProps: menuPaper }}
            sx={{ minWidth: 220 }}
          >
            {manageable.map((workspace) => (
              <MenuItem key={workspace.id} value={workspace.id}>
                {workspace.name}
              </MenuItem>
            ))}
          </TextField>
        ) : null
      }
    >
      <Surface>
        <WorkspaceView key={chosen} workspaceId={chosen} user={user} audience="customer" />
      </Surface>
    </AppPage>
  );
}
